import React from 'react';
import {useFormState, useWatch} from "react-hook-form";
import {Nav} from "react-bootstrap";
import SoftBadge from "../../../components/common/SoftBadge";
import {getDecidedFromArrays} from "../helpers";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";

const TabBadge = ({isInvalid, addedItems, changedItems}) => {
    const countDecided = getDecidedFromArrays(addedItems, changedItems);
    const totalCount = addedItems.length + changedItems.length;
    return (
        <SoftBadge pill bg={isInvalid ? "danger" : "primary"}>
            {isInvalid && <FontAwesomeIcon icon={"exclamation-triangle"} size={"lg"} title={"Error in tab"} />}
            {countDecided}/{totalCount}
        </SoftBadge>)
}

const TabNav = () => {
    const [addedBillingAddresses, changedBillingAddresses, addedBillingGroups, changedBillingGroups, addedLocations, changedLocations, addedPractitioners, changedPractitioners, addedPractitionerLocations, changedPractitionerLocations] = useWatch({name: ["addedBillingAddresses", "changedBillingAddresses", "addedBillingGroups", "changedBillingGroups", "addedLocations", "changedLocations", "addedPractitioners", "changedPractitioners", "addedPractitionerLocations", "changedPractitionerLocations"]});
    const {errors} = useFormState();
    return (
        <Nav variant={"tabs"}>
            <Nav.Item><Nav.Link eventKey={"rosterLoadDetails"}>Roster Load Details</Nav.Link></Nav.Item>
            <Nav.Item>
                <Nav.Link eventKey={"billingGroups"}>Billing Groups <TabBadge isInvalid={!!errors?.addedBillingGroups} addedItems={addedBillingGroups} changedItems={changedBillingGroups}/></Nav.Link>
            </Nav.Item>
            <Nav.Item>
                <Nav.Link eventKey={"practitioners"}>Practitioners <TabBadge isInvalid={!!errors?.addedPractitioners} addedItems={addedPractitioners} changedItems={changedPractitioners}/></Nav.Link>
            </Nav.Item>
            <Nav.Item>
                <Nav.Link eventKey={"locations"}>Practice Locations <TabBadge isInvalid={!!errors?.addedLocations} addedItems={addedLocations} changedItems={changedLocations}/></Nav.Link>
            </Nav.Item>
            <Nav.Item>
                <Nav.Link eventKey={"practitionerLocations"}>Practitioner Locations <TabBadge isInvalid={!!errors?.addedPractitionerLocations} addedItems={addedPractitionerLocations} changedItems={changedPractitionerLocations}/></Nav.Link>
            </Nav.Item>
            <Nav.Item>
                <Nav.Link eventKey={"billingAddresses"}>Remittance Addresses <TabBadge isInvalid={!!errors?.addedBillingAddresses} addedItems={addedBillingAddresses} changedItems={changedBillingAddresses}/></Nav.Link>
            </Nav.Item>
        </Nav>
    )
}
export default TabNav
